// tslint:disable:max-classes-per-file

import React from "react";

export interface CommonProps {
  model: string;
  formState: Forms.EnquiryForm;
  className?: string;
  id?: string;

  /**
   * User that the enquiry is for.
   */
  user: IUser;
}

export abstract class EnquiryFormSection<Props = {}, State = {}> extends React.Component<CommonProps & Props, State> {
  /**
   * Compare props for testing validity
   * Optimisation to ensure that each interaction doesn't cause each question to update its validity unnecessarily
   */
  protected abstract shouldUpdateValidity(oldProps: Readonly<CommonProps&Props>, newProps: Readonly<CommonProps&Props>): boolean;

  /**
   * Should dispatch an action to set the validity of the form question in the redux store.
   */
  protected abstract syncValidity(formState: Forms.EnquiryForm): void;

  public componentWillReceiveProps(newProps: Readonly<CommonProps&Props>) {
    if (this.shouldUpdateValidity(this.props, newProps)) {
      this.syncValidity(newProps.formState);
    }
  }

  public componentWillMount() {
    this.syncValidity(this.props.formState);
  }
}

const minPasswordLength = 8;

export class Validators {
  public static required = (val: string) => val != null && val.trim().length > 0;
  public static lastFourDigits = (val: string) => val != null && val.trim().length === 4 && /^\d+$/.test(val);
}

export const getTravellerCount = (state: Forms.EnquiryFormTravellers) => Object.keys(state.ageRangeIds || {})
  .map(k => state.ageRangeIds[k])
  .reduce((a, b) => (a || 0) + (b || 0), 0);
